export type * from './types';

export { default as customMerge } from './customMerge';
export { default as deepMerge } from './deepMerge';
export { default as deepNestedMerge } from './deepNestedMerge';
